import type { CcmTranslationsResponse } from '@arhs-fleetback/types/entities/ccm';
import { combineReducers } from 'redux';

import type { Action } from 'modules/global/generic.types';
import loading from 'modules/global/reducers/generic.loading';
import type { MayBe } from 'modules/global/typing/common/common';
import { createReducer } from 'utils/ReduxUtils';

import { CLEAR_CCM_DATA, FETCH_CCM_DATA, FETCH_CCM_DATA_SUCCESS, INIT_CCM_LANGUAGE, SAVE_CCM_DATA, SAVE_CCM_DATA_SUCCESS, SELECT_CCM_LANGUAGE } from '../actionTypes';
import { parseCcmContent } from '../utils';

const reset = () => null;

const handleCCMData = (payload: MayBe<CcmTranslationsResponse> | null) => {
  if (!payload) {
    return null;
  }
  return parseCcmContent(payload);
};

export default combineReducers({
  language: createReducer<string | null>(null, {
    [SELECT_CCM_LANGUAGE]: (_, { payload }: Action<string>) => payload as string,
    [INIT_CCM_LANGUAGE]: (_, { payload }: Action<string>) => payload as string,
    [CLEAR_CCM_DATA]: reset,
  }),
  content: createReducer<CcmTranslationsResponse | null>(null, {
    [FETCH_CCM_DATA_SUCCESS]: (_, { payload }: Action<CcmTranslationsResponse>) => handleCCMData(payload),
    [SAVE_CCM_DATA_SUCCESS]: (_, { payload }: Action<CcmTranslationsResponse>) => handleCCMData(payload),
    [SELECT_CCM_LANGUAGE]: reset,
    [CLEAR_CCM_DATA]: reset,
  }),
  isFetching: loading(FETCH_CCM_DATA),
  isSaving: loading(SAVE_CCM_DATA),
});
